import { useEffect } from "react";
import { headingWords } from "@/lib/workspace/use-title-off-screen";

const PRODUCT = "People AI";

/** The unread count the bell keeps in front of the tab's title: "(3) Residents | People AI". */
export const COUNT_PREFIX = /^\(\d+\+?\) /;

/** A tab names its screen (WCAG 2.4.2). A route that declares no title reads as the product
 * alone, so the screen's h1 lends it one ("Residents | People AI"); a declared title wins. */
export function useHeadingTitle() {
  useEffect(() => {
    let ours: string | null = null;
    let frame = 0;
    const apply = () => {
      frame = 0;
      const prefix = COUNT_PREFIX.exec(document.title)?.[0] ?? "";
      const bare = document.title.slice(prefix.length);
      if (bare !== PRODUCT && bare !== ours) return;
      /* The app's own page first; a portal or a signed-out page has no app shell around it. */
      const heading =
        document.querySelector<HTMLElement>("#main-content h1") ??
        document.querySelector<HTMLElement>("h1");
      const name = heading ? headingWords(heading) : null;
      const next = name ? `${name} | ${PRODUCT}` : PRODUCT;
      ours = name ? next : null;
      if (bare !== next) document.title = prefix + next;
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(apply);
    };
    /* One read a frame however busy the page is; the head is watched for the router's title. */
    const observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    schedule();
    return () => {
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);
}
